<template>
  <!--Фото-примеры + Видео-->
  <div class="uk-width-1-1 uk-margin-medium-top">
    <!--Фото-примеры-->
    <div class="uk-background-muted uk-padding-small">
      <div class="uk-margin uk-grid uk-flex-middle uk-grid-small" data-uk-grid>
        <div class="uk-text-bold uk-width-expand">
          Примеры {{ examples && examples.length >= 0 ? '(' + examples.length + ')' : '' }}
        </div>
        <div class="uk-width-auto">
          <div class="uk-margin uk-grid uk-flex-middle uk-grid-small" data-uk-grid>
            <div>
              <button class="uk-button uk-button-success uk-margin-small-left"
                      type="button"
                      :disabled="!dataChanged"
                      @click="saveExamples()"
                      data-uk-tooltip="Сохранить">
                <md-icon>done</md-icon>
                <span v-if="loading" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
              </button>
            </div>
            <div>
              <button class="uk-button uk-button-danger"
                      @click="reset()"
                      type="button"
                      :disabled="!dataChanged"
                      data-uk-tooltip="Сбросить">
                <md-icon>close</md-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <hr class="uk-margin">
      <!--      <div class="uk-margin-small-top uk-text-small uk-text-muted">-->
      <!--        имена файлов картинок будут заменяться при загрузке + номер по порядку, например "sample-for-retoucher-before1"-->
      <!--        или "sample-for-retoucher-after1"-->
      <!--      </div>-->
      <div class="uk-grid-divider uk-grid-small uk-grid uk-margin" data-uk-grid>
        <!--Left side-->
        <div class="uk-width-1-4 tm-left-slides-list">
          <!--List-->
          <ul class="uk-tab uk-tab-left uk-sortable">
            <template v-for="(example, key) in examples">
              <li v-if="!example.removed"
                  class="tm-block-item"
                  :key="key"
                  :class="'uk-link-text uk-text-lowercase ' + (key === activeExampleKey ? ' uk-active ' : '')">
                <a v-if="example.type === 'image'"
                   @click="activeExampleKey = key">
                  sample-for-retoucher-{{ key + 1 }}
                </a>
                <a v-if="example.type === 'video'"
                   @click="activeExampleKey = key">
                  video-lesson-{{ key + 1 }}
                </a>
                <div class="uk-position-center-right uk-position-small">
                  <ul class="uk-iconnav uk-flex-nowrap">
                    <li>
                      <button class="uk-link-text"
                              type="button"
                              @click="confirmRemoveExample(key)"
                              data-uk-tooltip="title: Удалить набор">
                        <md-icon>delete</md-icon>
                      </button>
                    </li>
                  </ul>
                </div>
              </li>
            </template>
          </ul>
          <!--Buttons-->
          <div class="uk-margin">
            <div class="uk-grid-small uk-child-width-1-2 uk-grid" data-uk-grid>
              <div>
                <button class="uk-button tm-button-success uk-width-1-1 tm-light"
                        style="padding: 0"
                        type="button"
                        v-if="countOfNew <= 0"
                        :disabled="countOfNew > 0"
                        @click="addNewExample('image')"
                        data-uk-tooltip="Добавить фото">
                  <md-icon>add</md-icon>
                  images
                </button>
              </div>
              <div>
                <button class="uk-button tm-button-success uk-width-1-1 tm-light"
                        style="padding: 0"
                        type="button"
                        v-if="countOfNewVideo <= 0"
                        :disabled="countOfNewVideo > 0"
                        @click="addNewExample('video')"
                        data-uk-tooltip="Добавить видео">
                  <md-icon>add</md-icon>
                  video
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--Right side-->
        <div class="uk-width-3-4">
          <ul style="list-style: none;">
            <!--Существующий пример-->
            <template v-for="(example, key) in examples">
              <li :key="key"
                  v-if="example.type === 'image' && key === activeExampleKey"
                  :id="'example'+key">
                <div class="uk-h6">
                  Before
                </div>
                <!--блок фото before-->
                <div class="uk-grid-small uk-child-width-1-2 uk-grid uk-margin-small-top" data-uk-grid>
                  <div>
                    <div class="uk-height-medium uk-position-relative">
                      <div class="uk-height-1-1 tm-example-img">
                        <a class="uk-flex uk-flex-center uk-flex-middle uk-margin-remove uk-text-center uk-height-1-1">
                          <!--после загрузки src меняется-->
                          <img class="example1-before" alt="" v-if="example.image_before" :src="example.image_before">
                          <img class="example1-before" alt="" src="/img/images.png" v-else>
                        </a>
                      </div>
                      <!--удаление фото-->
                      <button v-if="example.image_before"
                              class="uk-position-top-right uk-button uk-button-danger uk-icon tm-light tm-light-hover tm-button-add_"
                              style="padding: 0 7px;"
                              type="button"
                              @click="removeImage(example, example.id, 'image_before')"
                              data-uk-tooltip="Удалить фото">
                        <md-icon>delete</md-icon>
                      </button>
                      <!--размеры фото-->
                      <!--                      <div class="uk-position-top-left tm-file-rez">-->
                      <!--                        <span>600</span>-->
                      <!--                        ×-->
                      <!--                        <span>400</span>-->
                      <!--                      </div>-->
                    </div>
                  </div>
                  <div>
                    <div class="uk-width-1-1 uk-margin-small-bottom uk-form-custom" data-uk-form-custom="target: true">
                      <input type="file"
                             accept="image/jpeg,image/png"
                             @change="upload($event, 'image_before')">
                      <input class="uk-input uk-form-width-medium" type="text" placeholder="Выбрать фото" disabled>
                      <button class="uk-button tm-button-success tm-light">
                        <md-icon>download</md-icon>
                      </button>
                    </div>
                    <div class="uk-margin-small-top">
                      <input type="text"
                             class="uk-input uk-width-1-1"
                             :value="example.image_before"
                             disabled>
                    </div>
                    <div class="uk-margin-small-top tm-text-small uk-text-muted" style="line-height: 1.3">
                      Допустимые форматы: jpeg, jpg, png<br>
                      Максимальный размер: 5Mb<br>
                      Максимальный размер фото по большей стороне: 1600px
                    </div>
                    <!--                  <div class="uk-margin-small-top uk-text-small uk-text-muted">-->
                    <!--                    при удалении/добавлении фото удаляется из папки и новое залитое фото будет иметь имя удаленного-->
                    <!--                    "sample-for-retoucher-before1"-->
                    <!--                  </div>-->
                  </div>
                </div>
                <hr class="uk-margin">
                <!--блок фото after-->
                <div class="uk-h6">
                  After
                </div>
                <div class="uk-grid-small uk-child-width-1-2 uk-grid uk-margin-small-top" data-uk-grid>
                  <div>
                    <div class="uk-height-medium uk-position-relative">
                      <div class="uk-height-1-1 tm-example-img">
                        <a class="uk-flex uk-flex-center uk-flex-middle uk-margin-remove uk-text-center uk-height-1-1">
                          <img class="example1-after" alt="" v-if="example.image_after" :src="example.image_after">
                          <img class="example1-after" alt="" v-else src="/img/images.png">
                        </a>
                      </div>
                      <!--удаление фото-->
                      <button v-if="example.image_after"
                              class="uk-position-top-right uk-button uk-button-danger uk-icon tm-light tm-light-hover tm-button-add_"
                              style="padding: 0 7px"
                              type="button"
                              @click="removeImage(example, example.id, 'image_after')"
                              data-uk-tooltip="Удалить фото">
                        <md-icon>delete</md-icon>
                      </button>
                      <!--размеры фото-->
                      <!--                    <div class="uk-position-top-left tm-file-rez">-->
                      <!--                      <span>600</span>-->
                      <!--                      ×-->
                      <!--                      <span>400</span>-->
                      <!--                    </div>-->
                    </div>
                  </div>
                  <div>
                    <div class="uk-width-1-1 uk-margin-small-bottom uk-form-custom" data-uk-form-custom="target: true">
                      <input type="file" accept="image/jpeg,image/png" @change="upload($event, 'image_after')">
                      <input class="uk-input uk-form-width-medium" type="text" placeholder="Выбрать фото" disabled>
                      <button class="uk-button tm-button-success tm-light">
                        <md-icon>download</md-icon>
                      </button>
                    </div>
                    <div class="uk-margin-small-top">
                      <input type="text"
                             class="uk-input uk-width-1-1"
                             :value="example.image_after"
                             disabled>
                    </div>
                    <div class="uk-margin-small-top tm-text-small uk-text-muted" style="line-height: 1.3">
                      Допустимые форматы: jpeg, jpg, png<br>
                      Максимальный размер: 5Mb<br>
                      Максимальный размер фото по большей стороне: 1600px
                    </div>
                    <!--                  <div class="uk-margin-small-top uk-text-small uk-text-muted">-->
                    <!--                    при удалении/добавлении фото удаляется из папки и новое залитое фото будет иметь имя удаленного-->
                    <!--                    "sample-for-retoucher-after1"-->
                    <!--                  </div>-->
                  </div>
                </div>
              </li>
              <li v-if="example.type === 'video' && key === activeExampleKey"
                  :key="key">
                <!--Видео-->
                <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
                  <div class="uk-width-auto">
                    Ссылка на видео:
                  </div>
                  <div class="uk-width-expand">
                    <input class="uk-input"
                           type="text"
                           @change="dataChanged = true"
                           v-model="example.video_lesson">
                  </div>
                </div>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      activeExampleKey: 0,
      examples: {...this.editedFunction.examples},
      loading: false,
      dataChanged: false,
    };
  },
  props: {editedFunction: {type: [Object, Array]}},
  created() {
    this.examples = JSON.parse(JSON.stringify(this.editedFunction.examples));
  },
  watch: {
    editedFunction: function (newVal, oldVal) { // watch it
      this.examples = JSON.parse(JSON.stringify(newVal.examples));
    }
  },
  computed: {
    countOfNew() {
      return this.examples ? this.examples.filter((value) => {
        return value.type === 'image' && value.new
      }).length : 0;
    },
    countOfNewVideo() {
      return this.examples ? this.examples.filter((value) => {
        return value.type === 'video' && value.new
      }).length : 0;
    }
  },
  methods: {
    removeImage(example, id, type) {
      if (!confirm("Are you sure you want to delete the image?"))
        return;
      this.examples = this.examples.map(function (value) {
        if (value.id === id) {
          value[type] = null;
        }
        return value;
      });
      this.dataChanged = true;
    },
    confirmRemoveExample(id) {
      if (confirm("Are you sure you want to delete the example?"))
        this.removeExample(id);
    },
    removeExample(id) {
      const button = document.querySelector(`[data-uk-toggle="target: #example${id}; animation: uk-animation-fade"]`);
      if (button) {
        button.setAttribute('data-uk-toggle', '');
      }
      this.examples = this.examples.map((value, index) => {
        if (index === id) {
          value.removed = true;
        }
        return value;
      });
      this.dataChanged = true;
    },
    addNewExample(type = 'image') {
      if (type === 'image') {
        if (this.countOfNew > 0) {
          return;
        }

        this.examples.push({
          image_before: '',
          image_after: '',
          type: type,
          new: true,
          order: this.examples.length,
        });
      } else if (type === 'video') {
        if (this.countOfNewVideo > 0) {
          return;
        }
        this.examples.push({
          video_lesson: '',
          type: type,
          new: true,
          order: this.examples.length + 10,
        });
      }
      let lastKey = 0;
      this.examples.map((value, index) => lastKey = index);
      this.activeExampleKey = lastKey;
      this.dataChanged = true;
    },
    async upload($event, type) {
      if ($event.target.files[0]) {
        let data = new FormData();
        data.append('file', $event.target.files[0]);
        await axios.post(`${process.env.VUE_APP_API_BASE_URL}/func/` + this.editedFunction.id + `/examples/upload`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        }).then(res => {
          this.dataChanged = true;
          this.examples[this.activeExampleKey][type + '_path'] = res.data.storage_path;
          this.examples[this.activeExampleKey][type] = res.data.path;
          UIkit.notification({message: 'Uploaded', pos: 'top-center', status: 'success', timeout: 1500})

        }).catch(err => {
          UIkit.notification({message: err.response.data.message, pos: 'top-center', status: 'error', timeout: 1500})
        });

      }
    },
    checkExamples(examples) {
      let errors = examples.filter(function (example) {
        if ((!example.video_lesson && (!example.image_before || !example.image_after)) && !example.removed) {
          UIkit.notification({
            message: 'There is not enough data. Upload a photo or add a video',
            pos: 'top-center',
            status: 'info',
            timeout: 1500
          })
          return true;
        }
        return false;
      });
      return errors.length > 0 ? false : true;
    },
    async saveExamples() {
      let data = new FormData();
      this.loading = true;
      data.append('examples', JSON.stringify(this.examples));
      data.append('order_function_id', this.editedFunction.id);
      if (!this.checkExamples(this.examples)) {
        this.loading = false;
        return;
      }
      await axios.post(`${process.env.VUE_APP_API_BASE_URL}/func/` + this.editedFunction.id + `/examples`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }).then(async res => {
        this.dataChanged = false;
        await this.$store.dispatch('functionsEdit/functionsList');
        UIkit.notification({message: 'Saved', pos: 'top-center', status: 'success', timeout: 1500})
      }).catch(err => {
        UIkit.notification({message: err.response.data.message, pos: 'top-center', status: 'error', timeout: 1500})
      });

      this.loading = false;
    },
    reset() {
      if (this.dataChanged) {
        if (!confirm("Do you really want to reset all changes?")) {
          return;
        }
      }
      this.examples = JSON.parse(JSON.stringify(this.editedFunction.examples));
      this.activeExampleKey = 0;
      this.dataChanged = 0;
    }
  }
}
</script>
<style>
  .uk-button-danger:disabled {
    background-color: #9b5752;
    color: #999;
    border-color: #9b5752;
    cursor: no-drop;
  }
</style>